/// <amd-module name="Core/Medius.Core.Web/Scripts/components/sendEmailDialog/sendEmailDialog"/>
import { LocalizationContext, ModalDialogShell } from "@medius/ui-controls";
import * as React from "react";
import { SendEmailDialogForm } from "./sendEmailDialogForm";
import { mapFromNorthstarToApa } from "Core/Medius.Core.Web/Scripts/lib/northstarLocalization";
import { getCultureCode } from "Core/Medius.Core.Web/Scripts/Medius/lib/utils/user";
import { Contact, Recipient, SendEmailDialogFormFields } from "./types";

export interface SendEmailDialogProps {
    isOpen: boolean;
    title: string;
    onSendAction: (fields: SendEmailDialogFormFields) => void;
    onRequestClose: () => void;
    addressBook: Contact[];
    recipients: Recipient[];
    ccs: Recipient[];
    sendMeACopy: boolean;
    subject: string;
    body: string;
}

export const SendEmailDialog: React.FC<SendEmailDialogProps> = (props: SendEmailDialogProps) => {
    const { addressBook, title, onSendAction, onRequestClose, recipients, ccs, sendMeACopy, subject, body, isOpen } = props;

    return (
        <LocalizationContext.Provider value={{
            translate: (key: string, defaultValue?: string) => mapFromNorthstarToApa(key, defaultValue),
            getLocale: () => getCultureCode()
        }}>
            <ModalDialogShell
                data-testid="send-email-dialog"
                isOpen={isOpen}
                title={title}
                hasHeader={false}
                height="content"
                onRequestClose={onRequestClose}>
                {dialogProps => (
                    <SendEmailDialogForm
                        addressBook={addressBook}
                        recipients={recipients}
                        ccs={ccs}
                        sendMeACopy={sendMeACopy}
                        subject={subject}
                        body={body}
                        headerProps={dialogProps.headerProps}
                        onRequestClose={props.onRequestClose}
                        onSendAction={onSendAction}
                    />)}
            </ModalDialogShell>
        </LocalizationContext.Provider>
    );
};
